import React from 'react'

const ViewAccountSummary = () => {
    return (
        <>
            <div className="card-header">
                <h1>Account Summary</h1>
            </div>
            <div className="card-body">
                <div className="table-responsive account-summary-table">
                    <table className="table table-borderless">
                        <tbody>
                            <tr>
                                <td>
                                    <p>Credit Limit</p>
                                    <h6>2,300,000.00</h6>
                                </td>
                                <td>
                                    <p>Outstanding</p>
                                    <h6>1,126,654.00</h6>
                                </td>
                                <td>
                                    <p>Pending Orders</p>
                                    <h6>356,036.00</h6>
                                </td>
                                <td>
                                    <p>Pending Delivery</p>
                                    <h6>26,653.00</h6>
                                </td>
                                <td>
                                    <p>Overdue</p>
                                    <h6>23,000.00</h6>
                                </td>
                                <td>
                                    <p>Available Room</p>
                                    <h6>135,568.00</h6>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div></>
    )
}

export default ViewAccountSummary